import React from 'react';
import { Menu } from 'semantic-ui-react';
import Selectors from '@/layout/hooks/selectors';
import FairLaunchers from './FairLaunchers';

const RibbonLaunchers = () => {
  const { context } = Selectors.useLayoutContext();
  const Component = { fair: FairLaunchers }[context];

  return (
    <Menu icon="labeled" className="launcher aridhia-ribbon-launchers">
      {Component && <Component />}
    </Menu>
  );
};

export default RibbonLaunchers;
